var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"padding":"30px 0px"},attrs:{"id":"container"}},[_c('ejs-schedule',{attrs:{"height":_vm.height,"selectedDate":_vm.selectedDate,"views":_vm.views,"eventSettings":_vm.eventSettings}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }